// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../components/cms/index.generated';
export const CtaBoxFragmentDoc = gql`
    fragment ctaBox on ProductPageDetails {
  ctaPerksLink {
    ...link
  }
  ctaPerksList {
    title
  }
}
    ${LinkFragmentDoc}`;